import React, { useState, useEffect } from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

const MultipleSelect = ({ addresses = [], setAccueil, defaultValue = [], color }) => {
    const theme = createTheme({
        typography: { htmlFontSize: 10 },
        overrides: {
            MuiFormControl: {
                root: {
                    margin: '0px',
                    width: '500px'
                }
            }
        }
    });
    const { fetch, topbar } = useSelector(state => state.config)
    const [personName, setPersonName] = useState([]);
    const [state, setState] = useState(false)

    const handleChange = (event) => {
        const { target: { value } } = event
        setState(true)
        setAccueil(value.join(','))
        setPersonName(typeof value === 'string' ? value.split(',') : value)
    }

    useEffect(() => {
        setState(false)
    }, [fetch, topbar])

    console.log('defaultValue : ', defaultValue)
    console.log('personName : ', personName)

    return (
        <ThemeProvider theme={theme}>
            <FormControl sx={{ m: 1, width: 300 }}>
                <Select
                    id="demo-multiple-chip"
                    multiple
                    value={state ? personName : defaultValue}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: false }}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                                <Chip key={value} label={value} sx={{ color: '#FFF', fontSize: '1.8rem', backgroundColor: color }} />
                            ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                >
                    {addresses.map((name) => (
                        <MenuItem
                            key={name}
                            value={name}
                            style={getStyles(name, personName, theme)}
                        >
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </ThemeProvider>
    );
}

export default MultipleSelect